import { academyCustomCSS } from '~/constants';
import { LogOutButton } from '~/clc/features/learner-navigation/components/AcademyThemeNavigation/AcademyThemeNavigation.styles';
import { I18n } from '~/common/explicit-exports';

const TRANSLATED_LOGIN = I18n.t('js.academy.navigation.login');

export const LogInButton = ({ linkColor, linkHoverColor }) => (
  <LogOutButton
    className={`logout-button ${academyCustomCSS.header.loginButton}`}
    color={linkColor}
    hoverColor={linkHoverColor}
    href="/login"
  >
    {TRANSLATED_LOGIN}
  </LogOutButton>
);
